import { ApiProductField } from '../models/product-api.models';
import { parseBankDetails } from '../models/bank-details.models';

export type AssureRecord = Record<string, unknown>;

export function getBottomSheetFields(fields: ApiProductField[] = []): ApiProductField[] {
  return fields
    .filter((field) => field.belongsToBottomSheet && (field.type || '').toLowerCase() !== 'button')
    .sort(
      (a, b) =>
        (a.ordreAffichage ?? a.position ?? 0) - (b.ordreAffichage ?? b.position ?? 0),
    );
}

export function validateAssuresData(
  assures: AssureRecord[],
  fields: ApiProductField[],
  allBeneficiaryDataRequired = true,
): boolean {
  if (!assures.length) {
    return false;
  }

  if (!allBeneficiaryDataRequired) {
    return true;
  }

  for (const assure of assures) {
    for (const field of fields) {
      if (!field.holdData) {
        continue;
      }
      const value = assure[field.name];
      if ((field.type || '').toLowerCase() === 'toggle') {
        const bank = parseBankDetails(value);
        if (!bank.enabled) {
          continue;
        }
        if (!bank.bankId || !bank.accountNumber) {
          return false;
        }
        continue;
      }
      if (value == null) {
        return false;
      }
      if (typeof value === 'string' && !value.trim()) {
        return false;
      }
      if (Array.isArray(value) && !value.length) {
        return false;
      }
    }
  }

  return true;
}

export function validateSharesSum(assures: AssureRecord[], fields: ApiProductField[]): boolean {
  if (!assures.length) {
    return false;
  }

  const shareField = fields.find((field) => field.belongsToBottomSheet && field['isAShare']);
  if (!shareField?.name) {
    return true;
  }

  let sum = 0;
  for (const assure of assures) {
    const raw = assure[shareField.name];
    const parsed = Number.parseInt(String(raw ?? ''), 10);
    if (!Number.isNaN(parsed)) {
      sum += parsed;
    }
  }

  return sum === 100;
}

export function validateSharesSumByInsuranceType(
  assures: AssureRecord[],
  fields: ApiProductField[],
): boolean {
  if (!assures.length) {
    return false;
  }

  const shareField = fields.find((field) => field.belongsToBottomSheet && field['isAShare']);
  if (!shareField?.name) {
    return true;
  }

  let sumVie = 0;
  let sumDeces = 0;

  for (const assure of assures) {
    const typeInsurance = String(assure['typeInsurance'] ?? '')
      .toLowerCase()
      .trim();
    const parsed = Number.parseInt(String(assure[shareField.name] ?? ''), 10);
    if (Number.isNaN(parsed)) {
      continue;
    }

    if (typeInsurance === 'vie') {
      sumVie += parsed;
    } else if (typeInsurance === 'décès' || typeInsurance === 'deces') {
      sumDeces += parsed;
    }
  }

  return (sumVie === 100 && sumDeces === 100) || (sumVie === 100 && sumDeces === 0);
}
